/* ==========================================================
   Motion layer
   - Headings (h1-h3) reveal word by word
   - Text, images, product cards, accordions, custom-section items fade up on scroll (staggered)
   - Product details stagger in on load
   - Hero parallax + scroll progress bar
   The inline script in layout/theme.liquid adds .js-anim only when motion is allowed
   (not in the theme editor, not for reduced-motion users).
   ========================================================== */
(function () {
  var root = document.documentElement;
  if (!root.classList.contains('js-anim')) return;

  var BLOCKS =
    'main .text-block, main .image-block, main product-card, main .accordion, main [data-cf-reveal], ' +
    'footer .text-block';
  var HEADINGS = 'main h1, main h2, main h3, footer h2';

  /* ---------- Split headings into words ---------- */
  function splitHeading(h) {
    var plain = Array.prototype.every.call(h.childNodes, function (n) {
      return n.nodeType === 3 || n.nodeName === 'BR';
    });
    var text = (h.textContent || '').trim().replace(/\s+/g, ' ');

    if (plain && text) {
      h.setAttribute('aria-label', text);
      h.textContent = '';
      text.split(' ').forEach(function (word, i, all) {
        var outer = document.createElement('span');
        outer.className = 'cf-w';
        outer.setAttribute('aria-hidden', 'true');
        var inner = document.createElement('span');
        inner.textContent = word;
        inner.style.setProperty('--i', i);
        outer.appendChild(inner);
        h.appendChild(outer);
        if (i < all.length - 1) h.appendChild(document.createTextNode(' '));
      });
    }
    h.classList.add('cf-split');
  }

  /* ---------- Observer ---------- */
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('cf-in');
        io.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -6% 0px', threshold: 0.08 }
  );

  function setup(scope) {
    (scope || document).querySelectorAll(HEADINGS).forEach(function (h) {
      if (h.classList.contains('cf-split')) return;
      splitHeading(h);
      io.observe(h);
    });

    var groups = new Map();
    (scope || document).querySelectorAll(BLOCKS).forEach(function (el) {
      if (el.dataset.cfBound) return;
      if (el.closest('.product-details')) return; // product details use the load stagger instead
      el.dataset.cfBound = '1';
      var parent = el.parentElement;
      var index = groups.get(parent) || 0;
      groups.set(parent, index + 1);
      el.style.setProperty('--cf-delay', Math.min(index, 6) * 90 + 'ms');
      io.observe(el);
    });
  }

  setup(document);
  root.classList.add('cf-anim-ready');

  // Re-run for content Horizon swaps in (recommendations, variant changes, filters)
  var mo = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) setup(node.parentElement || document);
      });
    });
  });
  var main = document.querySelector('main');
  if (main) mo.observe(main, { childList: true, subtree: true });

  /* ---------- Scroll progress + hero parallax ---------- */
  var bar = document.createElement('div');
  bar.className = 'cf-progress';
  bar.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);

  var hero = document.querySelector('.shopify-section[id*="__hero_"]');
  var wrapper = document.querySelector('.page-wrapper');
  var ticking = false;

  function scroller() {
    if (wrapper && wrapper.scrollHeight > wrapper.clientHeight + 1) {
      var oy = getComputedStyle(wrapper).overflowY;
      if (oy === 'auto' || oy === 'scroll') return wrapper;
    }
    return document.scrollingElement || document.documentElement;
  }

  function update() {
    ticking = false;
    var el = scroller();
    var max = el.scrollHeight - el.clientHeight;
    var p = max > 0 ? el.scrollTop / max : 0;
    bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';

    if (hero) {
      var r = hero.getBoundingClientRect();
      if (r.bottom > 0) {
        var shift = Math.max(0, -r.top);
        hero.style.setProperty('--cf-parallax', (shift * 0.3).toFixed(1) + 'px');
        hero.style.setProperty('--cf-hero-fade', Math.max(0, 1 - shift / (r.height * 0.8)).toFixed(3));
      }
    }
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();
